/**
 * Price utility functions
 */
(() => {
  if (typeof theme === 'undefined') {
    window.theme = {};
  }

  theme.priceUtil = {};

  /**
   * Strips currency symbols from a formatted price string.
   * @param {String} priceString - The formatted price string.
   * @returns {String} - The price string without currency symbols.
   */
  theme.priceUtil.stripCurrencySymbols = function(priceString) {
    if (!priceString) return priceString;
        
    const hideCurrencySymbol = (typeof theme !== 'undefined' && theme.settings && theme.settings.hideCurrencySymbol);
    
    if (!hideCurrencySymbol) return priceString;
    
    let stripped = String(priceString);
        
    const symbols = ['€', '£', '$', '¥', '₹', '₽', '₩', '₪', '₦', '₨', '₫', '₭', '₮', '₯', '₰', '₱', '₲', '₳', '₴', '₵', '₶', '₷', '₸', '₺', '₻', '₼', '₾', '₿'];
    symbols.forEach(symbol => {
      stripped = stripped.replace(new RegExp(symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '');
    });
        
    const codes = ['USD', 'EUR', 'GBP', 'JPY', 'AUD', 'CAD', 'CHF', 'CNY', 'INR', 'NZD', 'SGD', 'HKD', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'RUB', 'BRL', 'MXN', 'ZAR', 'KRW', 'TRY', 'ILS', 'THB', 'MYR', 'PHP', 'IDR', 'VND'];
    codes.forEach(code => {      
      stripped = stripped.replace(new RegExp(`\\s*${code}\\s*`, 'gi'), '');
    });
        
    stripped = stripped.replace(/\s+/g, ' ').trim();
    
    return stripped;
  };
})();
